Ext.define('SA.view.CrosstabToolbar', {
    extend: 'SA.view.Toolbar',

    items: [
        {
            xtype: 'pvt-text',
            text: 'Cells Display:'
        }, {
            xtype: 'combo-button',
            itemId: 'modeDropdown',
            textField: 'label',
            ui: 'underline',
            value: 'default',
            valueField: 'value',

            items: [
                {
                    label: 'Vertical %, Index, Horizontal %',
                    value: 'default'
                }, {
                    label: 'Sample, Weighted (000), Total %',
                    value: 'metadata'
                }
            ]
        }, {
            xtype: 'pvt-text',
            padding: '10 10 10 20',
            text: 'Location:'
        }, {
            xtype: 'pvt-location-dropdown',
            itemId: 'locationDropdown'
        }, {
            xtype: 'pvt-text',
            padding: '10 10 10 20',
            text: 'Dataset:'
        }, {
            xtype: 'pvt-text-value',
            itemId: 'datasetText'
        }, {
            xtype: 'pvt-fill'
        }, {
            xtype: 'pvt-view-actions-button',
            itemId: 'viewActionsButton',
            margin: '0 10 0 0'
        }, {
            xtype: 'pvt-export-button',
            margin: '0 10 0 0'
        }
    ],

    initComponent() {
        this.callParent();

        this.modeDropdown = this.down('#modeDropdown');
        this.locationDropdown = this.down('#locationDropdown');
        this.datasetText = this.down('#datasetText');
        this.viewActionsButton = this.down('#viewActionsButton');

        this.viewActionsButton
            .setProjectView(this.model)
            .addEditItem()
            .addSeparator()
            .addDeleteItem();
    },

    initEvents() {
        this.callParent();

        this.modeDropdown.on('change', this.onModeDropdownChange, this);
    },

    onModeDropdownChange(dropdown, value) {
        this.fireEvent('change:mode', value === 'default');
    },

    refresh({location, datasetName, isDefaultMode}) {
        var locationValue = SA.data.LocationsCache.get(location),
            locationItems = [locationValue];

        this.locationDropdown.setItemsAndValue(locationItems, locationValue);
        this.datasetText.update(datasetName);
        this.modeDropdown.setValue(isDefaultMode ? 'default' : 'metadata');
    }
});